import {React, forwardRef, useEffect, useLayoutEffect } from 'react'
import '../components/HomeProcess.css';

import { gsap } from "gsap";
import $ from 'jquery';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin();
gsap.registerPlugin(ScrollTrigger);



const HomeProcess = forwardRef((props, ref) => {


  return (
    <section ref={ref} className="process">
        <div className="container">
            <div className='solar-system'>
                <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" height="70dvh"  viewBox="-5 -5 670 670">
                    <circle id="galaxyPath" fillRule="evenodd" clipRule="evenodd" cx="330" cy="330" r="330" 
                    fill="none" stroke="#222" strokeWidth="3" strokeDasharray="2100" strokeDashoffset="-2100" />

                    <circle id="galaxyPathActive" fillRule="evenodd" clipRule="evenodd" cx="330" cy="330" r="330" 
                    fill="none" stroke="#fa263d" strokeWidth="6" strokeDasharray="2100" strokeDashoffset="-2100" />
                </svg>
                <div className="planet-wrapper">
                    {
                        props.processSteps.map((step, index)=>
                        (
                            // index < props.processSteps.length-1 ? (
                            <div key={index} className={`planet planet-${index + 1}`}></div>
                            // ) : null
                        ))
                    }
               </div>
                <div className="heading detailed">Process That Delivers</div>
                <div className="content-wrapper detailed">
                    
                    <div className="content">
                    {
                        props.processSteps.map((step, index)=>
                        (
                           <div key={index}>{step.title}</div>
                           
                        ))
                    }
                    </div>

                   

                  

                </div>
                 <div className='details'>
                       {
                        props.processSteps.map((step, index)=>
                        (
                            <div className={`planet-desc-${index+1}`} key={index}>
                                <ul>
                                {
                                    
                                    step.desc.map((list, index2) =>
                                    (
                                        <li key={index2}><span>{list}</span></li>

                                    ))
                                
                                }
                                </ul>
                            </div>
                           
                        ))
                    }

                    </div>
                
            </div>
        </div>


    </section>
  )
})

export default HomeProcess
